import classNames from 'classnames'
import { ProgressBar } from '@winnin/winnin_ui.components.progress-bar'

import { DEFAULT_BACKGROUND_COLOR, DEFAULT_FOREGROUND_COLOR, DEFAULT_TEXT_COLOR } from './storage-progress-bar.consts'
import type { StorageProgressBarViewProps } from './storage-progress-bar.types'

import './storage-progress-bar.styles.scss'

export const StorageProgressBarView = ({
  percentage,
  label,
  className,
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
  foregroundColor = DEFAULT_FOREGROUND_COLOR,
  textColor = DEFAULT_TEXT_COLOR,
}: StorageProgressBarViewProps) => {
  return (
    <section className={classNames('StorageProgressBar', className)} aria-label="Storage usage indicator">
      <ProgressBar percentage={percentage} backgroundColor={backgroundColor} foregroundColor={foregroundColor} />
      <span className="StorageProgressBar-label" style={{ color: textColor }} aria-live="polite">
        {label}
      </span>
    </section>
  )
}
